import { render } from "./SleepImproveScheme.vue?vue&type=template&id=45f64d2c&scoped=true&ts=true"
import script from "./SleepImproveScheme.vue?vue&type=script&lang=ts"
export * from "./SleepImproveScheme.vue?vue&type=script&lang=ts"

import "./SleepImproveScheme.vue?vue&type=style&index=0&id=45f64d2c&scoped=true&lang=stylus"

import exportComponent from "D:\\zhongzhi\\wuzangceping_sahngyeban\\health-WeChat-small-program-page\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-45f64d2c"]])

export default __exports__